import { Alert, Button, Container } from "reactstrap";

const ErrorAlert = ({ error, onRetry }) => {
    return (
        <Container className="mt--7" fluid>
            <Alert color="danger">
                <strong>Error loading tokens:</strong>{" "}
                {error?.message || "Unknown error occurred"}
                {onRetry && (
                    <Button color="link" onClick={onRetry} className="ml-2">
                        Try Again
                    </Button>
                )}
            </Alert>
        </Container>
    );
};

export default ErrorAlert;
